import { baseUrl, defaultAddErrorMessage, errorTranslate } from "./util";
import axios from "axios";
import Swal from "sweetalert2";
import { check2FARequired } from "./Profile/2faApi";

export const login = (
  email,
  password,
  setErrorMessage = function () {
    return;
  },
  setShow2FAPrompt = function () {
    return;
  },
  after
) => {
  setErrorMessage("");
  const data = JSON.stringify({
    email: email,
    password: password,
  });

  const config = {
    method: "post",
    url: baseUrl + "/api/accounts/auth/login",
    headers: {
      "Content-Type": "application/json",
      // "Access-Control-Allow-Origin": "*",
      // "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      if (JSON.stringify(response.data).includes("access")) {
        localStorage.setItem("access_token", response.data.access);
        // if(after)
        //   after()

        check2FARequired().then((result) => {
          if (result.requires_2fa) {
            // Show 2FA verification component
            setShow2FAPrompt(true);
          } else {
            // No 2FA required, proceed with login
            window.location.reload(false);
          }
        });
      }
    })
    .catch(function (error) {
      if (error.response.status !== 200) {
        setErrorMessage(JSON.stringify(error.response.data));
      }
      console.log(error);
    });
};

export const logout = () => {
  localStorage.removeItem("access_token", "");
  window.location.reload(false);
};

export const registerApi = ({
  email,
  firstName,
  familyName,
  businessName,
  password,
  confirmPassword,
  cvrNumber,
  roles,
  user_info,
  businessAddress,
  successMessage,
  setErrorMessage = function () {
    return;
  },
  callback = function () {
    return;
  },
  setRegisterSuccess,
}) => {
  const data = JSON.stringify({
    email: email,
    firstName: firstName,
    familyName: familyName,
    businessName: businessName,
    password: password,
    confirmPassword: confirmPassword,
    CVRNumber: cvrNumber,
    user_info: user_info,
    businessAddress: businessAddress,
  });

  const config = {
    method: "post",
    url: baseUrl + "/api/business/register",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      setErrorMessage();
      // login(email, password, function () { return; }, () => {
      //   roles.map((role) => {
      //     addRole({ role: role })
      //   })
      // })
      localStorage.setItem("newly_registered_az", "true");

      setRegisterSuccess(true);

      Swal.fire({
        title: "Success!",
        icon: "success",
        text: successMessage,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
        timer: 5000,
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(function (error) {
      console.log(error);
      const errorMessage = Object.entries(error.response.data).map(
        ([key, value]) => {
          if (Array.isArray(value))
            return (
              key +
              ": " +
              value.reduce((total, val) => total + " " + val) +
              "\n"
            );
          else if (typeof value == "object") {
            return Object.entries(value)
              .map(([key1, value1]) => {
                return (
                  key1 +
                  ": " +
                  value1.reduce((total, val) => total + " " + val) +
                  ""
                );
              })
              .reduce((total, val) => total + "\n" + val);
          }
        }
      );
      setErrorMessage(errorMessage);
      setRegisterSuccess(false);
      // error.response.data
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: defaultAddErrorMessage,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const getInfoRoles = (
  businessSizeList,
  setBusinessSizeList,
  setName
) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/accounts/me",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      setName(
        response.data.data.profile.firstName +
          " " +
          response.data.data.profile.familyName
      );
      if (response.data.data.roles.length > 1) {
        setBusinessSizeList(
          response.data.data.roles.reduce(function (a, b) {
            return (a.name || a) + ", " + b.name;
          })
        );
      } else {
        setBusinessSizeList(response.data.data.roles[0].name);
      }
    })
    .catch(function (error) {
      console.log(error);
    });

  // return ;
};

export const getProfile = ({
  setEmail = function () {
    return;
  },
  setName = function () {
    return;
  },
  setFamilyName = function () {
    return;
  },
  setLastLogin = function () {
    return;
  },
  setBackupEmail = function () {
    return;
  },
  setDateOfBirth = function () {
    return;
  },
  setGender = function () {
    return;
  },
  setPhoneNumber = function () {
    return;
  },
  setLocation = function () {
    return;
  },
  setVAT = function () {
    return;
  },
  setWebsite = function () {
    return;
  },
  setCompanyEmail = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/accounts/me",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      setName(response.data.data.profile.firstName);
      setEmail(response.data.data.profile.email);
      setFamilyName(response.data.data.profile.familyName);
      setLastLogin(response.data.data.profile.last_login);
      setBackupEmail(response.data.data.profile.backup_email);
      setPhoneNumber(response.data.data.profile.phone_number);
      setDateOfBirth(response.data.data.profile.date_of_birth);
      setGender(response.data.data.profile.gender);
      setLocation(response.data.data.profile.location);
      setWebsite(response.data.data.profile.website);
      setCompanyEmail(response.data.data.profile.company_email);
      if (response.data.data.profile.account) {
        setVAT(response.data.data.profile.account.cvr);
      }
    })
    .catch(function (error) {
      console.log(error);
    });

  // return ;
};

export const addRole = ({ role }) => {
  var config = {
    method: "post",
    url: baseUrl + "/api/accounts/roles/add",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: { id: role },
  };
  axios(config)
    .then(function (response) {})
    .catch((error) => {});
};

export const updateAccess = async ({ email, permission, modules, isStaff }) => {
  const data = JSON.stringify({
    email: email,
    permission: permission,
    modules: modules,
    is_staff: isStaff,
  });

  const config = {
    method: "post",
    url: baseUrl + "/api/accounts/access",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  await axios(config)
    .then(function (response) {
      // console.log('berhasil')
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWriteAccessList = ({ setData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/accounts/access/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      setData(response.data.data);
    })
    .catch(function (error) {
      console.log(error);
    });

  // return ;
};

export const validateUserData = (email, password, confirmPassword) => {
  const data = JSON.stringify({
    email: email,
    password: password,
    confirmPassword: confirmPassword,
  });

  const config = {
    method: "post",
    url: baseUrl + "/api/accounts/validate-user",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
};

export const deleteAccount = () => {
  const config = {
    method: "post",
    url: baseUrl + "/api/accounts/delete",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      logout();
    })
    .catch(function (error) {
      console.log(error);
    });

  // return ;
};

export const updateProfile = async (personalInfo) => {
  const data = {
    profile: {
      firstName: personalInfo.firstName,
      familyName: personalInfo.lastName,
      email: personalInfo.email,
      phone_number: personalInfo.phone_number,
      date_of_birth: personalInfo.date_of_birth,
      gender: personalInfo.gender,
      location: personalInfo.location,
      website: personalInfo.website,
      company_email: personalInfo.company_email,
    },
  };

  const config = {
    method: "put",
    url: baseUrl + "/api/accounts/update",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data,
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error.response?.data?.profile) {
      const profileErrors = error.response.data.profile;

      const errorMessage = Object.entries(profileErrors)
        .map(([field, message]) => `${field}: ${message}`)
        .join(", ");
      throw new Error(errorMessage);
    }
    throw new Error("Failed to update profile");
  }
};

export const changeUserPassword = (
  oldPassword,
  newPassword,
  confirmNewPassword,
  setPasswordError,
  setOldPassword,
  setNewPassword,
  setConfirmNewPassword
) => {
  const data = JSON.stringify({
    password: oldPassword,
    newPassword: newPassword,
    confirmNewPassword: confirmNewPassword,
  });

  const config = {
    method: "post",
    url: baseUrl + "/api/accounts/password/change",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      setOldPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
      setPasswordError(["Password successfully updated"]);
    })
    .catch(function (error) {
      setPasswordError(error.response.data.newPassword);
    });
};

export const resetUserPassword = (email, setLoading) => {
  const config = {
    method: "post",
    url: baseUrl + "/api/email/password/reset/",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      email,
    },
  };

  return axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Email Sent",
        icon: "success",
        text: "Please check your email to reset password",
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    })
    .catch(function (error) {
      const { data, status } = error.response;

      let text;
      if (status === 500) {
        text = "Internal Server Error. Please try again later";
      } else {
        text = JSON.stringify(data);
      }

      Swal.fire({
        title: "Error!",
        icon: "error",
        text: text,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    })
    .finally(function () {
      setLoading(false);
    });
};

export const resetUserPasswordVerify = (code) => {
  const config = {
    method: "get",
    url: baseUrl + `/api/email/password/reset/verify/?code=${code}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axios(config)
    .then(function (response) {})
    .catch(function (error) {
      const { data, status } = error.response;

      let text;
      if (status === 500) {
        text = "Internal Server Error. Please try again later";
      } else {
        text = JSON.stringify(data);
      }

      Swal.fire({
        title: "Error!",
        icon: "error",
        text: text,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const resetUserPasswordVerified = (code, password, setLoading) => {
  const data = JSON.stringify({
    code: code,
    password: password,
  });

  const config = {
    method: "post",
    url: baseUrl + "/api/email/password/reset/verified/",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success",
        icon: "success",
        text: "Password Reset",
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    })
    .catch(function (error) {
      const { data, status } = error.response;

      let text;
      if (status === 500) {
        text = "Internal Server Error. Please try again later";
      } else {
        text = JSON.stringify(data);
      }

      Swal.fire({
        title: "Error!",
        icon: "error",
        text: text,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    })
    .finally(function () {
      setLoading(false);
    });
};

export const getAccountInfo = async () => {
  const config = {
    method: "get",
    url: baseUrl + "/api/accounts/me",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  return await axios(config);
};

export const deleteWriteAccess = ({ id, callback = null }) => {
  const config = {
    method: "delete",
    url: baseUrl + "/api/accounts/access/delete/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
    });
};
